interface QuestionCategory {
  category: string;
  questions: string[];
}

export const questionData: QuestionCategory[] = [
  {
    category: "Seekers info",
    questions: [
      "What are the basic details of the seeker (age, gender, city, phone, email)",
      "Who is the roommate preference of seeker?",
    ],
  },
  {
    category: "Age and date of birth",
    questions: [
      "List of registered seekers who's birthday falls in a specific date range for this program?",
      "List of registered seekers from a specific city, age, gender, DOB for this program?",
      "Age distribution of registered seekers for this program?",
    ],
  },
  {
    category: "Location",
    questions: ["Top 10 cities by registered seekers for this program ?"],
  },
  {
    category: "Program stats",
    questions: [
      "How many times has the seeker been allocated a seat in comparison to registrations?",
      "How many programs did Seeker attend?",
      "List of seekers applied for the first time?",
      "List of seekers who have applied for more than n times but have not been allocated a seat?",
      "List of seekers who have requested for swap multiple times in the same program",
    ],
  },
];
